export const NO_CHANGES_MADE = "No Changes found to update";
export const TALHA_EMP_ID = "628c8c7c3912af2cb88df7fb";
export const MEEZAN_BANK_ACCOUNT = "02900105632718";
export const LATES_EXEMPTED_BY_SYSTEM = 2;
export const QUOTA_PER_MONTH = 1;
export const QUOTA_PER_YEAR = QUOTA_PER_MONTH * 12;
export const VEHICLE_TYPE = ["None", "Bike", "Car"];
export const SALARY_PLACEHOLDER = "XXXXX";
export const USER_ROLES=["Admin", "HR"];
export const CONTRACTS = [
  "Probationary",
  "Internee",
  "Permanent",
  "Hourly",
  "Resignation",
];

export const CONTRACT_STATUS = [
  "expired",
  "renewed",
  "terminated",
]
export const ADJUSTMENTS = [
  "Other",
  "Fuel",
  "Parking",
  "Overtime",
  "Loan",
  "Employee Fund",
];
export const ERROR_MESSAGE = "Something went wrong";
export const MODE_OF_PAYMENT = ["Bank Transfer", "Cheque", "Cash"];

export const GENDERS = [
  { value: "male", label: "Male" },
  { value: "female", label: "Female" },
];

export const SIGNATURES = [
  { value: "CEO", label: "CEO" },
  { value: "HR", label: "HR" },
];

export const OFFICE_DETAILS = {
  address:
    "Office no 1203, 12th Floor Al Hafeez Executive, 30-C3, Gulberg III, Lahore, 54660",
  phoneNumber: "+92-309-3512171",
  HREmail: "hr@shayansolution.com",
  websiteURL: "https://shayansolutions.com/",
};